module.exports = __webpack_public_path__ + "img/active-item-bg.0e32109a.png";